<style lang="scss" scoped="scoped">
	p {
		color: #303133;
	}

	.container::-webkit-scrollbar {
		display: none;
	}
</style>

<template>
	<div class="container" ref="container"
		style="overflow: auto;height: 100%;position: relative;padding: 20px;display: flex;flex-direction: column;justify-content: space-between;">
		<div ref="titleBar" class="titleBar" style="flex-shrink: 0;display: flex;align-items: center;">
			<p style="font-size: 16px;font-weight: 700;">
				{{$t('zongtizhibiao')}}

			</p>
			<p style="font-size: 12px;line-height: 22px;color: #C0C4CC;margin-left: 12px;"
				v-if="statistics.currentShift">
				{{$t('tongjishijian')}}&nbsp{{statistics.currentShift.begin}}&nbsp~&nbsp{{statistics.currentShift.end}}
			</p>
		</div>
		<div style="display: flex;justify-content: space-between;margin-top: 20px;flex: 1;">

			<div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between">
				<p>{{$t('zongtikaijilu')}}
					<el-tooltip class="item" effect="dark" :content="$t('zongtikaijilv_jisuangongshi')"
						placement="top-start">
						<i style="margin-left: 0px;color: #303133;" class="yicon yicon-help"></i>
					</el-tooltip>
				</p>
				<div style="display: flex;justify-content: space-between;">
					<div v-if="statistics.upEfficency!=null" style="font-weight: 700;font-size: 24px;">
						{{(statistics.upEfficency*100).toFixed(1)}}%
					</div>
					<div style="display: flex;align-items: center;">
						<div>
							<p style="color: #909399;">{{$t('zuorihuanbi')}}</p>
						</div>
						<!-- sanjiao_green -->
						<div style="margin-left: 8px;display: flex;align-items: center;">
							<img v-if="statistics.lastUpEfficencyRatio>=0" style="width: 8px;height: 4px;"
								src="../../../assets/img/home/sanjiao_red.png">
							<img v-if="statistics.lastUpEfficencyRatio<0" style="width: 8px;height: 4px;"
								src="../../../assets/img/home/sanjiao_green.png">
							<p v-if="statistics.lastUpEfficencyRatio>=0" style="margin-left: 4px;color: #F56C6C;">
								{{(statistics.lastUpEfficencyRatio*100).toFixed(1)}}%
							</p>
							<p v-if="statistics.lastUpEfficencyRatio<0" style="margin-left: 4px;color: #67C23A;">
								{{(statistics.lastUpEfficencyRatio*100).toFixed(1)}}%
							</p>
						</div>

					</div>
				</div>
				<p style="color: #909399;margin-top: 10px;">{{$t('jin7rikaijilv')}}</p>
				<div ref="chart1" style="flex: 1;">
					<div id="chart1" style="height: 100%;margin-top: 0px;">

					</div>
				</div>
			</div>
			<div style="flex: 1;display: flex;flex-direction: column;justify-content: space-between;margin-left: 40px;">
				<p>{{$t('zongtijiadonglu')}}
					<el-tooltip class="item" effect="dark" :content="$t('zongtijiadonglv_jisuangongshi')"
						placement="top-start">
						<i style="margin-left: 0px;color: #303133;" class="yicon yicon-help"></i>
					</el-tooltip>
				</p>
				<div style="display: flex;justify-content: space-between;">
					<div v-if="statistics.timeEfficency!=null" style="font-weight: 700;font-size: 24px;">
						{{(statistics.timeEfficency*100).toFixed(1)}}%
					</div>
					<div style="display: flex;align-items: center;">
						<div>
							<p style="color: #909399;">{{$t('zuorihuanbi')}}</p>
						</div>
						<!-- sanjiao_green -->
						<div style="margin-left: 8px;display: flex;align-items: center;">

							<img v-if="statistics.lastTimeEfficencyRatio>=0" style="width: 8px;height: 4px;"
								src="../../../assets/img/home/sanjiao_red.png">
							<img v-if="statistics.lastTimeEfficencyRatio<0" style="width: 8px;height: 4px;"
								src="../../../assets/img/home/sanjiao_green.png">
							<p v-if="statistics.lastTimeEfficencyRatio>=0" style="margin-left: 4px;color: #F56C6C;">
								{{(statistics.lastTimeEfficencyRatio*100).toFixed(1)}}%
							</p>
							<p v-if="statistics.lastTimeEfficencyRatio<0" style="margin-left: 4px;color: #67C23A;">
								{{(statistics.lastTimeEfficencyRatio*100).toFixed(1)}}%
							</p>

						</div>

					</div>
				</div>
				<p style="color: #909399;margin-top: 10px;">{{$t('jin7rijiadonglv')}}</p>
				<div ref="chart2" style="flex: 1;">
					<div id="chart2" style="height: 100%;margin-top: 0px;">

					</div>
				</div>
			</div>

		</div>



	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_home_quota',
		components: {

		},

		data() {
			return {
				timmer: null,
				chart1: null,
				options1: null,
				chart2: null,
				options2: null,
				statistics: {},
				chart1Times: [],
				chart1Values: [],
				chart2Times: [],
				chart2Values: [],
			};
		},
		created() {
			// this.timmer = setInterval(() => {
			// 	this.getEfficiencyStatistics()
			// }, 120000)
			this.getEfficiencyStatistics()
		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		activated() {
			this.resize()
		},
		watch: {
			'$attrs.orgId'(newValue, oldValue) {
				if (this.utils.isEqual(newValue, oldValue)) {
					return
				}
				this.getEfficiencyStatistics()
			},
			
		},
		destroyed() {
			clearInterval(this.timmer)
		},
		methods: {

			async getEfficiencyStatistics() {
				let response = await this.http.get('/web/equipment/home/getEfficiencyStatistics', {params:{orgId: this.$attrs.orgId}})
				this.statistics = response.data
				this.chart1Times = this.statistics.upRate7List.map(item => {
					return item.time
				})
				this.chart1Values = this.statistics.upRate7List.map(item => {
					return item.value*100
				})
				this.chart2Times = this.statistics.timeRate7List.map(item => {
					return item.time
				})
				this.chart2Values = this.statistics.timeRate7List.map(item => {
					return item.value*100
				})
				if (!this.chart1) {
					this.initChart1()
				}else{
					this.option1.xAxis.data = this.chart1Times;
					this.option1.series[0].data = this.chart1Values;
					this.chart1.setOption(this.option1)
				}
				if (!this.chart2) {
					this.initChart2()
				}else{
					this.option2.xAxis.data = this.chart2Times;
					this.option2.series[0].data = this.chart2Values;
					this.chart2.setOption(this.option2)
				}
				// this.resize()
			},
			resize() {
				setTimeout(() => {
					this.chart1.resize()
					this.chart2.resize()

				}, 800)

			},
			initChart1() {

				this.option1 = {
					grid: {
						left: '-20',
						right: '10',
						bottom: '0',
						top: '10',
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						data: this.chart1Times,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#909399', //更改坐标轴文字颜色
								fontSize: 12 //更改坐标轴文字大小
							}
						},
						axisLine: {
							lineStyle: {
								color: '#909399', //更改坐标轴文字颜色
							}
						},
						axisTick: {
							inside: true
						}
					},
					yAxis: {
						show: false,
						type: 'value'
					},
					series: [{
						data: this.chart1Values,
						type: 'line',
						symbol: 'none',
						itemStyle: {
							normal: {
								color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#419FFF',
									},
									{
										offset: 1,
										color: 'rgba(227, 227, 227,0.3)',
									},
								]),
								barBorderRadius: 6,
							},
							// normal: {
							// 	lineStyle: {
							// 		color: this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
							// 		    offset: 0, 
							// 		    color: rgba(57, 107, 209, 0.19) 
							// 		}, { 
							// 		    offset: 0.5, 
							// 		    color: rgba(65, 159, 255, 0.19)
							// 		}, { 
							// 		    offset: 1, 
							// 		    color: rgba(65, 159, 255, 0) 
							// 		}]),//线条渐变色 
							// 	}
							// }
						},
						areaStyle:{
							color: {
							    type: 'linear',
							    x: 0,
							    y: 0,
							    x2: 0,
							    y2: 1,
							    colorStops: [{
							        offset: 0, color: 'rgba(57, 107, 209, 0.19)' // 0% 处的颜色
							    }, {
							        offset: 0.01, color: 'rgba(65, 159, 255, 0.19)' // 100% 处的颜色
							    }, {
							        offset: 1, color: 'rgba(65, 159, 255, 0)' // 100% 处的颜色
							    }],
							    global: false // 缺省为 false
							}
						}
						
					}]
				};
				var chartDom = document.getElementById('chart1');
				this.chart1 = this.echarts.init(chartDom);
				this.option1 && this.chart1.setOption(this.option1);
			},
			initChart2() {

				this.option2 = {
					grid: {
						left: '-20',
						right: '10',
						bottom: '0',
						top: '10',
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						data: this.chart2Times,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#909399', //更改坐标轴文字颜色
								fontSize: 12 //更改坐标轴文字大小
							}
						},
						axisLine: {
							lineStyle: {
								color: '#909399', //更改坐标轴文字颜色
							}
						},
						axisTick: {
							inside: true
						}
					},
					yAxis: {
						show: false,
						type: 'value'
					},
					series: [{
						data: this.chart2Values,
						type: 'line',
						symbol: 'none',
						itemStyle: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#419FFF',
								},
								{
									offset: 1,
									color: 'rgba(227, 227, 227,0.3)',
								},
							]),
							barBorderRadius: 6,
						},
						areaStyle:{
							color: {
							    type: 'linear',
							    x: 0,
							    y: 0,
							    x2: 0,
							    y2: 1,
							    colorStops: [{
							        offset: 0, color: 'rgba(57, 107, 209, 0.19)' // 0% 处的颜色
							    }, {
							        offset: 0.01, color: 'rgba(65, 159, 255, 0.19)' // 100% 处的颜色
							    }, {
							        offset: 1, color: 'rgba(65, 159, 255, 0)' // 100% 处的颜色
							    }],
							    global: false // 缺省为 false
							}
						}
					}]
				};
				var chartDom = document.getElementById('chart2');
				this.chart2 = this.echarts.init(chartDom);
				this.option2 && this.chart2.setOption(this.option2);
			}

		},






	};
</script>
